import React from 'react';
import PropTypes from 'prop-types';
import { AlertStyleEnum, ServiceAlertIcon } from './styled';

function DynamicAlertIcon({ type, ...restProps }) {
  const { Icon } = AlertStyleEnum[type];

  // since this is a thin wrapper around a set of icons props spreading
  // is allowed here so all props are forwards to the selected icon
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Icon type={type} {...restProps} />;
}

DynamicAlertIcon.propTypes = {
  /** Alert type; determines the icon that is returned by this component */
  type: PropTypes.string.isRequired,
};

export { DynamicAlertIcon, AlertStyleEnum, ServiceAlertIcon };
export default DynamicAlertIcon;
